import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { errorMessage } from "../../utils/errorMessage";

export const actionToGetTrendyolCategoryAttributes = createAsyncThunk(
  "jobInactionToGetTrendyolCategoryAttributes ",
  async (categoryId, thunkAPI) => {
    const token = thunkAPI.getState().adminUserToLogin.adminUserInfo.token; // Gets the current Redux state

    try {
      // Call your API function here
      const { data } = await axios.get(
        "/api/trendyol/getTrendyolCategoryAttributes",
        {
          params: {
            categoryId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    } catch (error) {
      let { message } = errorMessage(error);

      throw new Error(message);
    }
  }
);

const getTrendyolCategoryAttributes = createSlice({
  name: "sliceToGetTrendyolCategoryAttributes",
  initialState: {
    categoryAttributes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(actionToGetTrendyolCategoryAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        actionToGetTrendyolCategoryAttributes.fulfilled,
        (state, action) => {
          state.loading = false;
          state.error = null;
          state.categoryAttributes = action.payload;
        }
      )
      .addCase(
        actionToGetTrendyolCategoryAttributes.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        }
      );
  },
});

const reducerToGetTrendyolCategoryAttributes =
  getTrendyolCategoryAttributes.reducer;

export default reducerToGetTrendyolCategoryAttributes;
